// extracted by mini-css-extract-plugin
export var textInput = "_fm-0";